module.exports = __webpack_public_path__ + "img/windshield_150.25287dfb.webp";